module.exports = __webpack_public_path__ + "img/card_coupon.9a7f27fb.png";